module.exports = __webpack_public_path__ + "img/resultado3.f45c4cc9.jpg";